import React from "react";

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement>{
  className?: string
}

export default function Label({className, children, ...attributes}: LabelProps) {
  // peer-invalid:text-primary
  return <label {...attributes} className={`font-bold font-compressed peer-focus:text-secondary ${className || ''}`}>{children}</label>
}

interface FloatingLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement>{
  className?: string
  size?: "md" | "lg"
  on?: string
}

export function  FloatingLabel({on="bg-surface", size="md", className, children, ...attributes}: FloatingLabelProps) {
  return <label className={`
  absolute 
  text-gray-500 
  duration-150 
  transform 
  z-10 
  origin-[0] 
  px-2 
  pointer-events-none
  ${size === "lg" ? "text-lg" : "text-base"}

  mt-0
  scale-[0.8]
  ${size === "lg" ? "-translate-y-7" : "-translate-y-6"}
  top-2.5
  left-2 
  font-semibold

  peer-focus:text-secondary 
  
  peer-placeholder-shown:scale-100
  peer-placeholder-shown:translate-y-0
  peer-placeholder-shown:top-2.5 
  peer-placeholder-shown:mt-px
  peer-placeholder-shown:font-normal

  peer-focus:scale-[0.8] 
  ${size === "lg" ? "peer-focus:-translate-y-7" : "peer-focus:-translate-y-6"}
  peer-focus:top-2.5
  peer-focus:mt-0
  peer-focus:font-semibold ${on} ${className || ''}`} {...attributes}>{children}</label>
}
